import {
  Component,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { CustomInterfacePlaceholderDirective } from "src/directive/custom-interface-placeholder.directive";
import { GenericBasicAggregateGUI } from "src/model/class/component classes/generic-basic-aggregate-gui";

@Component({
    selector: "app-two-or-more-buttons-template",
    templateUrl: "./two-or-more-buttons-template.component.html",
    styleUrls: ["./two-or-more-buttons-template.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TwoOrMoreButtonsTemplateComponent
  extends GenericBasicAggregateGUI
  implements OnInit, OnDestroy
{
  @ViewChild(CustomInterfacePlaceholderDirective, { static: true })
  componentHost: CustomInterfacePlaceholderDirective;

  constructor(_injector: Injector) {
    super(_injector);
  }

  ngOnInit() {}

  ngAfterContentInit() {
    this.componentHost.drawCustomInterfaceComponents(
      this.aggregate.listComponent,
      false,
      this.hAlign.CENTER,
      false
    );
  }
}
